/* eslint-disable no-unused-expressions */
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

const useRequestLoading = (requests = [], onFinish = () => {}, shouldNotSendRequests = false) => {
  const dispatch = useDispatch();
  const [isRequesting, setIsRequesting] = useState(!shouldNotSendRequests);
  const [errMessage, setErrorMessage] = useState('');
  const [runningRequests, setRunningRequests] = useState(requests.length);

  const onSuccess = () => setRunningRequests((prev) => prev - 1);

  const onError = (err, errStatus) =>
    setErrorMessage(`Request failed. Err status: ${errStatus}. Err message: ${err}`);

  useEffect(() => {
    if (shouldNotSendRequests) return;

    requests.forEach((r) => {
      const successBlock = r.payload?.successBlock;
      const errorBlock = r.payload?.errorBlock;

      r.payload.successBlock = () => {
        onSuccess();
        successBlock?.();
      };
      r.payload.errorBlock = (err, errStatus) => {
        onError(err, errStatus);
        errorBlock?.();
      };

      dispatch(r);
    });
  }, [shouldNotSendRequests]);

  useEffect(() => {
    if (!runningRequests) {
      setIsRequesting(false);
      onFinish();
    }
  }, [runningRequests]);

  useEffect(() => {
    if (errMessage) {
      setIsRequesting(false);
    }
  }, [errMessage]);

  return { isRequesting, errMessage };
};

export default useRequestLoading;
